/* eslint-disable quote-props */
/**
 * ## Estados ##
 */

export const STATES = Object.freeze({
  AC: 'Acre',
  AL: 'Alagoas',
  AM: 'Amazonas',
  AP: 'Amapá',
  BA: 'Bahia',
  CE: 'Ceará',
  DF: 'Distrito Federal',
  ES: 'Espírito Santo',
  GO: 'Goiás',
  MA: 'Maranhão',
  MG: 'Minas Gerais',
  MS: 'Mato Grosso do Sul',
  MT: 'Mato Grosso',
  PA: 'Pará',
  PB: 'Paraíba',
  PE: 'Pernambuco',
  PI: 'Piauí',
  PR: 'Paraná',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RO: 'Rondônia',
  RR: 'Roraima',
  RS: 'Rio Grande do Sul',
  SC: 'Santa Catarina',
  SE: 'Sergipe',
  SP: 'São Paulo',
  TO: 'Tocantins',
});

export const getStates = () => Object.entries(STATES).map((item) => ({
  value: item[0],
  label: item[1],
}));

/**
 * ## Estados Civis
 */

const CIVIL_STATES = Object.freeze({
  'Solteiro': 'Solteiro(a)',
  'Casado': 'Casado(a)',
  'Viúvo': 'Viúvo(a)',
  'Separado': 'Separado(a)',
  'Divorciado': 'Divorciado(a)',
  'União Estável': 'União Estável',
});

export const getCilvilStates = () => Object.entries(CIVIL_STATES).map((item) => ({
  value: item[0],
  label: item[1],
}));
